import React from 'react';
import { ReceiptLineSummary, ReceiptTotalTitle } from '../../components';
import './PaymentConfirmation.scss';
import { CurrencyUtils, SharedUtils, TranslationUtils } from '../../utils';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { CookieKeys } from '../../types/keys.type';
import { Currency } from '../../types/preference.type';
import { AppRoutes } from '../../routes';

export interface PaymentConfirmationProps {
    isSuccessful?: boolean;
}

export const PaymentConfirmation: React.FC = () => {
    const intl = useIntl();
    const history = useHistory();
    const location = useLocation<PaymentConfirmationProps>();
    const { trip } = useSelector((store: StoreState) => store);
    const { reservation } = trip;
    let currency = SharedUtils.getCookie(CookieKeys.PREFERRED_CURRENCY) as any;
    currency = currency || Currency.USD;

    if (!reservation) {
        return null;
    }

    if (!location || !location.state || !location.state.isSuccessful) {
        history.push(AppRoutes.RESERVATION);
        return null;
    }
    const shouldShowPreviousBalance = reservation.balance > 0;

    return (
        <React.Fragment>
            <div className="payment-confirmation-header">
                <div tabIndex={0}>
                    <h1 className="heading-large page-title mb-0">{TranslationUtils.get('thank_you')}</h1>
                </div>
                <p tabIndex={0} className="body-regular mt-3">
                    {TranslationUtils.get('payment_trip_paid_in_full')}
                </p>
            </div>
            <ReceiptTotalTitle
                summary={{
                    total: reservation.balance,
                    currency: reservation.booked_currency_code || '',
                }}
                convertedSummary={{
                    total: reservation.converted_amount?.balance || 0,
                    currency: reservation.converted_amount?.currency || currency,
                    conversion_rate: reservation.converted_amount?.conversion_rate,
                }}
                locale={intl.locale}
            />
            <div className="payment-confirmation-content">
                {shouldShowPreviousBalance && (
                    <>
                        {
                            <ReceiptLineSummary
                                summaryTitle={TranslationUtils.get('previous_balance')}
                                summaryValue={CurrencyUtils.formatCurrency(
                                    reservation.balance,
                                    reservation.booked_currency_code || currency
                                )}
                                currency={reservation.booked_currency_code || ''}
                                locale={intl.locale}
                            />
                        }
                        <hr />
                    </>
                )}
            </div>
        </React.Fragment>
    );
};
